<template>
    <div class="animated fadeIn">
        <b-row class="mt-4">
            <b-col>
                <b-card no-body>
                    <b-card-header>
                        <span class="text-muted text-uppercase">
                            {{ title }}
                        </span>
                    </b-card-header>
                    <div class="py-3 px-5">
                        <b-form-group label="Note" :label-cols="2">
                            <b-form-textarea
                                rows="6"
                                placeholder="Enter a note..."
                                v-model="noteText"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button
                    @click="submit"
                    class="my-4 float-right py-3 px-5"
                    variant="success"
                >
                    <i class="fal fa-save" /> Save
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ToastNotifications from "../../../components/shared/mixins/ToastNotifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const NoteRepository = LabRepositoryFactory.get('note');

export default {
    name: "NotesForm",
    mixins: [ToastNotifications],
    props: {
        data_type: {
            type: String,
            required: true
        }
    },
    computed: {
        title() {
            return `${this.convertToSentenceCase(this.data_type)} Note Form`;
        },
        formattedDataType() {
            return this.formatDataType();
        },
    },
    data() {
        return {
            noteText: null,
            noteAttachableId: this.$route.params[Object.keys(this.$route.params)[0]],
        };
    },
    methods: {
        submit() {
            if (!this.noteText) {
                this.quickDangerToast("Missing Note", "Please enter a note before saving");
                return;
            }

            // generate a payload 
            const payload = {
                notes_attachable_type: this.formattedDataType,
                notes_attachable_id: this.noteAttachableId,
                note: this.noteText
            }

            // create the note
            NoteRepository.create(payload).then((response) => {
                if (response && response.status === 201) {
                    this.quickSuccessToast('Note Added!', 'The note has been added successfully');
                    //this.$router.back();
                    this.noteText = "";
                    this.$emit('noteSaved');
                }
            }).catch((err) => {
                this.quickDangerToast('Unable to add note', err);
            });
        },
        formatDataType() {
            // reassing the prop so we can manipulate it
            let dataType = this.data_type;

            // Make sure the type is PascalCase
            dataType = this.convertToPascalCase(dataType);
            
            // return the new data with the models linkage
            return `App\\Models\\${dataType}`;
        },
        convertToSentenceCase(str) {
            return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase());
        },
        convertToSnakeCase(str) {
            return str
                .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
                .map(x => x.toLowerCase())
                .join('_');
        },
        convertToPascalCase(str) {
            // convert the string to snake_case for easy conversion
            str = this.convertToSnakeCase(str);

            // reformat the snake_case string to Pascal case and return it
            return str.split("/")
                .map(snake => snake.split("_")
                    .map(substr => substr.charAt(0)
                        .toUpperCase() + substr.slice(1))
                    .join(""))
                .join("/");
        }
    }
};
</script>